/**
 * Genera el Recibo de Pago (ticket pequeño 80mm) cuando el evento queda LIQUIDADO.
 * Incluye links de Fotos y Videos si están configurados.
 */
import { jsPDF } from "jspdf";
import { toast } from "sonner";
import { PICPARTY_LOGO_BASE64 } from "../../../lib/picpartyLogo";
import { FORMA_PAGO_LABELS } from "../utils";

export const generateRecibo = async (contract) => {
    // Calcular altura dinámica (más alto si tiene links)
    const hasLinks = contract.link_fotos || contract.link_videos;
    const ticketHeight = hasLinks ? 200 : 170;
    const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [80, ticketHeight] });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const margin = 5;
    
    // Logo centrado (imagen gráfica)
    try {
      pdf.addImage(PICPARTY_LOGO_BASE64, 'PNG', (pageWidth - 25) / 2, 3, 25, 25);
    } catch(e) {
      console.error("Error cargando logo recibo:", e);
      pdf.setFontSize(12);
      pdf.setFont(undefined, 'bold');
      pdf.text("PIC PARTY", pageWidth / 2, 15, { align: 'center' });
    }
    
    let y = 32;
    
    // Título
    pdf.setFontSize(10);
    pdf.setFont(undefined, 'bold');
    pdf.text("RECIBO DE PAGO", pageWidth / 2, y, { align: 'center' });
    y += 6;
    pdf.setFontSize(8);
    pdf.setFont(undefined, 'normal');
    pdf.text("EVENTO LIQUIDADO", pageWidth / 2, y, { align: 'center' });
    y += 8;
    
    // Línea divisora
    pdf.setDrawColor(150);
    pdf.line(margin, y, pageWidth - margin, y);
    y += 6;
    
    // Datos del cliente
    pdf.setFontSize(7);
    pdf.setFont(undefined, 'bold');
    pdf.text("Cliente:", margin, y);
    pdf.setFont(undefined, 'normal');
    pdf.text(contract.client_name || '', margin + 15, y);
    y += 5;
    
    pdf.setFont(undefined, 'bold');
    pdf.text("Tel:", margin, y);
    pdf.setFont(undefined, 'normal');
    pdf.text(contract.client_phone || '', margin + 15, y);
    y += 5;
    
    pdf.setFont(undefined, 'bold');
    pdf.text("Fecha:", margin, y);
    pdf.setFont(undefined, 'normal');
    pdf.text(contract.event_date || '', margin + 15, y);
    y += 8;
    
    // Línea divisora
    pdf.line(margin, y, pageWidth - margin, y);
    y += 6;
    
    // Totales
    pdf.setFontSize(8);
    pdf.setFont(undefined, 'normal');
    pdf.text("Total Neto:", margin, y);
    pdf.text(`$${(contract.net_price || 0).toLocaleString()} MXN`, pageWidth - margin, y, { align: 'right' });
    y += 5;
    
    pdf.text("Abono:", margin, y);
    pdf.text(`$${(contract.anticipo_amount || 0).toLocaleString()} MXN`, pageWidth - margin, y, { align: 'right' });
    y += 5;
    
    pdf.setFont(undefined, 'bold');
    pdf.text("Saldo:", margin, y);
    pdf.text("$0 MXN", pageWidth - margin, y, { align: 'right' });
    y += 8;
    
    // Mensaje de liquidado
    pdf.setFillColor(34, 139, 34);
    pdf.rect(margin, y, pageWidth - (margin * 2), 8, 'F');
    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(7);
    pdf.text("** SERVICIO LIQUIDADO **", pageWidth / 2, y + 5.5, { align: 'center' });
    y += 14;
    
    // ============ LINKS DE FOTOSHARE ============
    if (hasLinks) {
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(8);
      pdf.setFont(undefined, 'bold');
      pdf.text("Tus Fotos y Videos aqui:", pageWidth / 2, y, { align: 'center' });
      y += 6;
      
      pdf.setFontSize(6);
      pdf.setFont(undefined, 'normal');
      if (contract.link_fotos) {
        pdf.text("FOTOS:", margin, y);
        y += 4;
        pdf.setTextColor(0, 0, 255);
        pdf.text(contract.link_fotos, margin, y);
        pdf.setTextColor(0, 0, 0);
        y += 6;
      }
      if (contract.link_videos) {
        pdf.text("VIDEOS:", margin, y);
        y += 4;
        pdf.setTextColor(0, 0, 255);
        pdf.text(contract.link_videos, margin, y);
        pdf.setTextColor(0, 0, 0);
        y += 6;
      }
      y += 2;
    }
    
    // Línea divisora
    pdf.setDrawColor(150);
    pdf.line(margin, y, pageWidth - margin, y);
    y += 5;
    
    // ============ DATOS FISCALES ============
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(6);
    pdf.setFont(undefined, 'bold');
    pdf.text("DATOS FISCALES:", margin, y);
    y += 4;
    pdf.setFont(undefined, 'normal');
    pdf.text("Adan Octavio Irigoyen Arias", margin, y);
    y += 3;
    pdf.text("RFC: IIAA8004021A9", margin, y);
    y += 6;
    
    // Fecha de emisión
    pdf.setTextColor(100, 100, 100);
    pdf.setFontSize(5);
    pdf.text(`Emitido: ${new Date().toLocaleString('es-MX')}`, pageWidth / 2, y, { align: 'center' });
    y += 3;
    pdf.text("(614) 272 5008 | WWW.PICPARTY.NET", pageWidth / 2, y, { align: 'center' });
    
    // Guardar (compatible con móviles)
    const fileName = `Recibo_${contract.client_name.replace(/\s+/g, '_')}.pdf`;
    const pdfBlob = pdf.output('blob');
    const blobUrl = URL.createObjectURL(pdfBlob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
    toast.success("Recibo de pago generado");
  };

/**
 * Recibo (ticket 80mm) de UN abono/pago individual: folio del contrato,
 * monto, fecha, método y saldo pendiente restante después de ese pago.
 */
export const generateAbonoRecibo = async (contract, abono, saldoRestante) => {
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [80, 150] });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const margin = 5;

  try {
    pdf.addImage(PICPARTY_LOGO_BASE64, 'PNG', (pageWidth - 22) / 2, 3, 22, 22);
  } catch (e) {
    console.error("Error cargando logo recibo de abono:", e);
    pdf.setFontSize(12);
    pdf.setFont(undefined, 'bold');
    pdf.text("PIC PARTY", pageWidth / 2, 15, { align: 'center' });
  }

  let y = 29;
  pdf.setFontSize(10);
  pdf.setFont(undefined, 'bold');
  pdf.text("RECIBO DE PAGO", pageWidth / 2, y, { align: 'center' });
  y += 5;
  pdf.setFontSize(7);
  pdf.setFont(undefined, 'normal');
  pdf.text(`Folio: ${contract.folio || '-'}`, pageWidth / 2, y, { align: 'center' });
  y += 7;

  pdf.setDrawColor(150);
  pdf.line(margin, y, pageWidth - margin, y);
  y += 6;

  pdf.setFontSize(7);
  pdf.setFont(undefined, 'bold');
  pdf.text("Cliente:", margin, y);
  pdf.setFont(undefined, 'normal');
  pdf.text(contract.client_name || '', margin + 18, y);
  y += 5;
  pdf.setFont(undefined, 'bold');
  pdf.text("Evento:", margin, y);
  pdf.setFont(undefined, 'normal');
  pdf.text(contract.event_date || '', margin + 18, y);
  y += 7;

  pdf.line(margin, y, pageWidth - margin, y);
  y += 6;

  pdf.setFontSize(8);
  pdf.setFont(undefined, 'bold');
  pdf.text("Fecha de pago:", margin, y);
  pdf.setFont(undefined, 'normal');
  pdf.text(abono.fecha || '', pageWidth - margin, y, { align: 'right' });
  y += 5;
  pdf.setFont(undefined, 'bold');
  pdf.text("Método:", margin, y);
  pdf.setFont(undefined, 'normal');
  pdf.text(FORMA_PAGO_LABELS[abono.forma_pago] || abono.forma_pago || '-', pageWidth - margin, y, { align: 'right' });
  y += 5;
  pdf.setFont(undefined, 'bold');
  pdf.text("Monto pagado:", margin, y);
  pdf.text(`$${(abono.monto || 0).toLocaleString()} MXN`, pageWidth - margin, y, { align: 'right' });
  y += 7;

  pdf.line(margin, y, pageWidth - margin, y);
  y += 6;

  pdf.setFont(undefined, 'bold');
  pdf.text("Saldo restante:", margin, y);
  pdf.text(saldoRestante > 0 ? `$${saldoRestante.toLocaleString()} MXN` : "$0 MXN (LIQUIDADO)", pageWidth - margin, y, { align: 'right' });
  y += 10;

  if (abono.nota) {
    pdf.setFontSize(6);
    pdf.setFont(undefined, 'italic');
    pdf.setTextColor(80, 80, 80);
    const notaLines = pdf.splitTextToSize(`Nota: ${abono.nota}`, pageWidth - margin * 2);
    pdf.text(notaLines, margin, y);
    y += notaLines.length * 3.2 + 4;
  }

  pdf.setTextColor(100, 100, 100);
  pdf.setFontSize(5);
  pdf.text(`Emitido: ${new Date().toLocaleString('es-MX')}`, pageWidth / 2, y, { align: 'center' });
  y += 3;
  pdf.text("(614) 272 5008 | WWW.PICPARTY.NET", pageWidth / 2, y, { align: 'center' });

  const fileName = `Recibo_${(contract.folio || contract.client_name || 'pago').replace(/\s+/g, '_')}_${(abono.fecha || '').replace(/-/g, '')}.pdf`;
  const pdfBlob = pdf.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
  toast.success("Recibo de pago generado");
};
